{
  "高级配置": "Advanced settings",
  "短信配置": "SMS configuration",
  "服务商配置": "Provider configuration",
  "请填写此项": "This field is required",
  "短信配置已保存": "SMS configuration saved",
  "短信服务商": "SMS provider",
  "创蓝": "Chuanglan",
  "启用短信": "Enable SMS",
  "已设置，留空保留原密钥": "Configured. Leave blank to keep the current secret.",
  "请输入 App Secret": "Enter App Secret",
  "首次配置或更换 App ID 时必须填写 App Secret": "App Secret is required for initial setup or a different App ID.",
  "短信签名": "SMS signature",
  "测试短信": "Test SMS",
  "发送测试短信": "Send test SMS",
  "请先保存并启用短信配置": "Save and enable SMS configuration first.",
  "使用已保存配置发送真实短信，可能产生费用；每 60 秒限发一次。": "Sends a real SMS using saved configuration. Charges may apply. Limited to once every 60 seconds.",
  "接收手机号": "Recipient phone number",
  "请输入大陆手机号": "Enter a mainland China phone number.",
  "模板编号": "Template code",
  "模板参数": "Template parameters",
  "按创蓝模板要求填写，无变量可留空": "Use the format required by your Chuanglan template. Leave blank for templates without variables.",
  "请先保存配置再测试": "Save configuration before testing.",
  "请输入 16–32 位回执密码": "Enter a 16–32 character receipt password.",
  "首次配置或更换回执用户名时必须填写回执密码": "Receipt password is required for initial setup or a different receipt username.",
  "服务商": "Provider",
  "输入完整手机号": "Enter the complete phone number",
  "已受理不代表已送达；最终状态以服务商回执为准。": "Accepted does not mean delivered. Final status is confirmed by provider receipts.",
  "结果待确认": "Unconfirmed",
  "已受理": "Accepted",
  "已送达": "Delivered",
  "提交失败": "Submission failed",
  "送达失败": "Delivery failed",
  "发送时间": "Sent at",
  "回执时间": "Receipt time",
  "失败原因": "Failure reason",
  "消息 ID": "Message ID",
  "用途": "Purpose",
  "业务": "Business",
  "计费条数": "Billable segments",
  "请求 ID": "Request ID",
  "短信日志": "SMS logs",
  "短信已受理，请到日志管理查看短信日志": "SMS accepted. View SMS logs under Log management.",
  "短信用途": "SMS purpose",
  "选择创蓝账号已开通的短信用途": "Select an SMS purpose enabled for your Chuanglan account.",
  "通知短信": "Notification SMS",
  "验证码短信": "Verification SMS",
  "营销短信": "Marketing SMS",
  "电商短信": "E-commerce SMS",
  "金融短信": "Finance SMS",
  "游戏短信": "Gaming SMS",
  "拉新短信": "Acquisition SMS",
  "回调验证用户名": "Callback authentication username",
  "回调验证密码": "Callback authentication password",
  "送达回执设置（已配置）": "Delivery receipt settings (configured)",
  "送达回执设置（可选）": "Delivery receipt settings (optional)",
  "用于自动更新日志中的送达状态。不配置也能发送短信，但只能确认是否已受理。": "Automatically updates delivery status in logs. SMS can be sent without this setup, but only acceptance can be confirmed.",
  "将此公网地址配置到创蓝，并联系创蓝技术支持设置相同的验证用户名和密码。": "Configure this public URL in Chuanglan and ask their support to set the same authentication username and password.",
  "将此公网地址配置到创蓝即可接收回执，验证用户名和密码可留空；如创蓝已配置验证，请填写相同值。": "Configure this public URL in Chuanglan to receive receipts. Leave the username and password blank unless authentication is already configured in Chuanglan; then enter the matching values.",
  "填写创蓝统一应用的 App ID，非短信 API 账号": "Enter the Chuanglan unified application App ID, not the SMS API account.",
  "需与此 App ID 在创蓝绑定的产品类型一致": "Must match the product type bound to this App ID in Chuanglan.",
  "{{seconds}} 秒后重试": "Retry in {{seconds}} seconds",
  "仅填写模板变量，按 param1、param2 顺序；无变量可留空": "Enter only template variables as param1, param2, etc. Leave blank if there are none.",
  "请输入单个对象的 JSON 数组，如 [{\"param1\":\"1234\"}]": "Enter a JSON array with one object, e.g. [{\"param1\":\"1234\"}].",
  "接入方式": "API mode",
  "国内短信 API（账号 / 密码）": "Domestic SMS API (account / password)",
  "统一应用（App ID / App Secret）": "Unified application (App ID / App Secret)",
  "API 账号": "API account",
  "API 密码": "API password",
  "请输入 API 密码": "Enter the API password",
  "取自创蓝「国内短信 → API 接口信息」": "From Chuanglan: Domestic SMS → API information",
  "首次配置、更换接入方式或账号时必须填写对应密钥": "Enter the matching secret when first configuring or changing the API mode or account.",
  "国际短信（已配置）": "International SMS (configured)",
  "国际短信": "International SMS",
  "用于中国大陆以外的手机号。国内短信仍走上面的模板。文案须包含 {code}。": "For phone numbers outside mainland China. Mainland numbers still use the templates above. The message must contain {code}.",
  "国际短信 App ID": "International SMS App ID",
  "国际短信密钥": "International SMS secret",
  "请输入国际短信密钥": "Enter the international SMS secret",
  "首次配置或更换国际短信账号时必须填写密钥": "A secret is required when first configuring or changing the international SMS account.",
  "国际短信用途": "International SMS purpose",
  "Sender ID": "Sender ID",
  "通用验证码文案": "General verification message",
  "找回密码专用文案": "Password reset message override",
  "中国大陆发送通道": "Mainland China channel",
  "国内通道（默认）": "Domestic channel (default)",
  "国际通道": "International channel",
  "中国大陆 +86 与其他国家 / 地区均使用国际通道。需在创蓝开通国内发送权限，正文含签名并完成报备。": "All destinations, including +86, use the international channel. Enable mainland delivery with Chuanglan and register signed message content first.",
  "中国大陆 +86 使用国内通道，其他国家 / 地区使用国际通道。": "Mainland China (+86) uses the domestic channel. Other destinations use the international channel.",
  "国内短信": "Domestic SMS",
  "已配置": "Configured",
  "未配置": "Not configured",
  "国内配置保留备用，当前 +86 使用国际通道。": "Domestic settings are retained. Mainland China (+86) currently uses the international channel.",
  "使用创蓝已审核的签名和模板发送。": "Send with signatures and templates approved by Chuanglan.",
  "验证码模板": "Verification templates",
  "默认用于登录、注册、找回密码等验证；专用模板留空时复用通用模板。param1 为 6 位验证码，有效期 5 分钟。": "Used by default for login, registration, password reset and other verification. Blank overrides use the general template. param1 is a six-digit code valid for 5 minutes.",
  "支持国际号码；发送 +86 需联系创蓝开通权限，并报备带签名的短信内容。": "Supports international numbers. To send to +86, ask Chuanglan to enable mainland delivery and approve signed message content.",
  "创蓝接入说明": "Chuanglan documentation",
  "填写国际短信统一应用的 App ID，不能使用国内 API 账号。": "Use the App ID for the international SMS unified application, not a domestic API account.",
  "请填写国际短信 App ID": "Enter the App ID for the international channel.",
  "可选，需按目的地要求注册；不能替代中国大陆短信正文中的签名。": "Optional. Registration depends on the destination. This does not replace the signature required in mainland China message content.",
  "验证码文案": "Verification messages",
  "默认用于各验证码场景，专用文案留空时复用通用文案。使用 {code} 代表验证码；发送 +86 须包含已报备的签名。": "Used by default for all verification. Blank overrides use the general message. Use {code} for the code; include the registered signature for +86.",
  "验证码文案须包含 {code}，且不能有其他占位符": "Include {code} and no other placeholders in the verification message.",
  "送达回执": "Delivery receipts",
  "仅用于国内通道的送达状态。国际通道当前记录受理结果，送达情况请在创蓝控制台查看。": "Delivery receipts apply to the domestic channel. International SMS logs record acceptance; check delivery in the Chuanglan console.",
  "测试国际短信": "Test international SMS",
  "请输入带国家区号的手机号，如 +8613800138000": "Enter a phone number with country code, such as +8613800138000.",
  "短信内容": "Message content",
  "发送 +86 时请填写已报备、带签名的完整正文。": "For +86, enter the full, approved message including its signature.",
  "用于登录、注册、找回密码和手机号绑定。示例：【你的签名】您的验证码为 {code}，5 分钟内有效，请勿泄露。{code} 会自动替换为验证码，“你的签名”请替换为已报备的签名。": "Used for login, registration, password reset and phone linking. Example: [Your signature] Your verification code is {code}. It expires in 5 minutes. Do not share it. {code} is replaced with the verification code. Replace \"Your signature\" with your registered signature.",
  "填写找回密码时发送的完整短信，{code} 会自动替换为验证码。示例：【你的签名】您正在找回密码，验证码为 {code}，5 分钟内有效。非本人操作请忽略。请将“你的签名”替换为已报备的签名。": "Enter the complete password reset SMS. {code} is replaced with the verification code. Example: [Your signature] Your password reset code is {code}. It expires in 5 minutes. Ignore this message if you did not request it. Replace \"Your signature\" with your registered signature.",
  "留空使用通用验证码模板": "Leave blank to use the general verification template",
  "留空使用通用验证码文案": "Leave blank to use the general verification message",
  "国际短信接入方式": "International SMS API mode",
  "国际短信 API（账号 / 密码）": "International SMS API (account / password)",
  "账号归属节点": "Account region",
  "按创蓝控制台显示的账号归属节点选择": "Select the account region shown in the Chuanglan console.",
  "上海": "Shanghai",
  "新加坡": "Singapore",
  "国际 API 账号": "International API account",
  "国际 API 密码": "International API password",
  "填写国际短信 API 账号，通常以大写 I 开头": "Enter the international SMS API account, usually starting with an uppercase I.",
  "请填写国际 API 账号": "Enter the international API account.",
  "首次配置、更换国际短信接入方式或账号时必须填写密钥": "A secret is required when first configuring or changing the international SMS mode or account."
}
